import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react';
import {
  TextField,
  Typography,
  Box,
  Button,
  DialogActions,
  FormControlLabel,
  Switch,
  FormControl,
  Select,
  MenuItem,
  Icon,
} from '@mui/material';
import { DateField } from '@mui/x-date-pickers';

import { convertFormData } from '../../utils/form';
import { FullWidthForm } from '../common/CommonDivs';
import { TableColumn } from '../../types/tableColumn';
import { InputType } from '../../types/inputTypes';
import * as MaterialIcons from '@mui/icons-material';

export interface AutoTableModalProps {
  title: string;
  headers: TableColumn[];
  existingItem?: Record<string, any>;
  onSubmit: (data: Record<string, any>) => void;
  onCancel: () => void;
}

const styles = {
  selectHeader: {
    fontSize: 12,
    position: 'relative',
    top:10,
    left: 13,
    color: '#0000009c',
  } as React.CSSProperties,
  select: {
    fontSize: 14,
    padding: 10,
    borderRadius: 5

  } as React.CSSProperties,
  iconLabel: {
    marginLeft: 10,

  } as React.CSSProperties
};

export const AutoTableModal = observer(
  ({
    title,
    headers,
    existingItem,

    onSubmit,
    onCancel,
  }: AutoTableModalProps) => {
    const [state, setState] = useState({});

    const isEdit = !!existingItem;
    const headersWithInputs = headers.filter((h) => !!h.inputType);

    useEffect(() => {

      if (!existingItem) return;
      
      for (const [key, value] of Object.entries(existingItem)) {
        if (key.includes('permission_')) {
          setState((s) => ({
            ...s,
            [key]: value,
          }));
        }
      }

    }, []);

    const submit: React.FormEventHandler<HTMLFormElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let data = {
        ...convertFormData<any>(e.target as HTMLFormElement),
        ...state,
      };

      console.log('data', data);

      headersWithInputs.forEach((h) => {
        const val = data[h.accessor];

        if (h.inputType === InputType.Number) {
          data[h.accessor] = Number(val);
        } else if (h.inputType === InputType.Boolean) {
          data[h.accessor] = Boolean(val);
        }
      });
      onSubmit(data);
    };

    return (
      <Box pl={3} pr={3} pt={3} pb={1}>
        <Typography component="h2" variant="h5" id="modal-title">
          {isEdit ? `Uppdatera ${title}` : `Skapa ny ${title}`}
        </Typography>
        <FullWidthForm noValidate onSubmit={submit}>
          {headersWithInputs.map((header, idx) => {
            const defaultValue = isEdit
              ? // @ts-ignore
                existingItem[header.accessor]
              : header.defaultValue || '';

            if (
              header.inputType === InputType.Text ||
              header.inputType === InputType.Number
            ) {
              return (
                <TextField
                  key={header.accessor}
                  variant="outlined"
                  margin="normal"
                  required={header.required}
                  fullWidth
                  id={header.accessor}
                  name={header.accessor}
                  label={header.title}
                  autoFocus={idx === 0}
                  type={
                    header.inputType === InputType.Number ? 'number' : 'text'
                  }
                  defaultValue={defaultValue}
                />
              );
            } else if (header.inputType === InputType.Textarea) {
              return (
                <TextField
                  key={header.accessor}
                  variant="outlined"
                  margin="normal"
                  required={header.required}
                  fullWidth
                  id={header.accessor}
                  name={header.accessor}
                  label={header.title}
                  rows={2}
                  multiline
                  defaultValue={defaultValue}
                />
              );
            } else if (header.inputType === InputType.Date) {
              return (
                <DateField
                  key={header.accessor}
                  variant="outlined"
                  margin="normal"
                  required={header.required}
                  fullWidth
                  id={header.accessor}
                  name={header.accessor}
                  label={header.title}
                  defaultValue={defaultValue}
                />
              );
            } else if (header.inputType == InputType.Boolean) {


              return (
                <FormControlLabel
                  key={header.accessor}
                  control={
                    <Switch
                      // @ts-ignore
                      checked={!!state[header.accessor]}
                      onChange={(event) => {
                        setState((s) => ({
                          ...s,
                          [header.accessor]: event.target.checked,
                        }));
                      }}
                    />
                  }
                  label={header.title}
                />
              );
            }
            else if (header.inputType == InputType.Select) {

              let values: {
                id: string;
                name: string;
              }[] = [];
        
              if (typeof header.values === 'string') {
                values = (header.values as string)
                  .split('\n')
                  .map((s) => ({ id: s, name: s }));
                values.unshift({ id: '', name: '' });
              } else if (Array.isArray(header.values)) {
                values = header.values.map((item) => ({
                  id: String(item.id),
                  name: item.name,
                }));
              }
        

              return ( <FormControl>
                <div style={styles.selectHeader}>{header.title}</div>
              <Select
                labelId={"select" + header.accessor}
                value={defaultValue}
                label={header.title}
                displayEmpty
                onChange={(e) => {                  
                  setState((s) => ({
                    ...s,
                    [header.accessor]: e.target.value,
                  }));

                  existingItem[header.accessor] = e.target.value;
                }}
              >
                {  values.map((item) => (
                  <MenuItem key={item.id} value={String(item.id)}>
                    {item.name}
                  </MenuItem>
                )) }
              </Select>
            </FormControl>
              )
            }

            else if (header.inputType === InputType.SelectIcon) {

              let values: {
                id: string;
                name: string;
              }[] = [];
        
              if (typeof header.values === 'string') {
                values = (header.values as string)
                  .split('\n')
                  .map((s) => ({ id: s, name: s }));
                values.unshift({ id: '', name: '' });
              } else if (Array.isArray(header.values)) {
                values = header.values.map((item) => ({
                  id: String(item.id),
                  name: item.name,
                }));
              }
        
              values = values.sort((a, b) => a.name.localeCompare(b.name));
              
              return ( <FormControl>
                <div style={styles.selectHeader}>{header.title}</div>
              <Select
                labelId={"select" + header.accessor}
                value={defaultValue}
                label={header.title}
                displayEmpty
                onChange={(e) => {                  
                  setState((s) => ({
                    ...s,
                    [header.accessor]: e.target.value,
                  }));

                  existingItem[header.accessor] = e.target.value;
                }}
              >
                {  values.map((item) => (
                  <MenuItem key={item.id} value={String(item.id)}>
                    {getIconComponent(item.id)}
                    <span style={styles.iconLabel} >{item.name}</span>
                  </MenuItem>
                )) }
              </Select>
            </FormControl>
              )
            }


            return null;
          })}
          <DialogActions>
            <Button color="secondary" type="button" onClick={onCancel}>
              {'Avbryt'}
            </Button>
            <Button color="primary" type="submit">
              {isEdit ? `Spara ${title}` : `Skapa ny ${title}`}
            </Button>
          </DialogActions>
        </FullWidthForm>
      </Box>
    );
  },
);

const kebabToCamelCase = (str) => {
  str = str.replace(/-./g, (match) => match[1].toUpperCase());
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Function to return the correct icon component based on the id
const getIconComponent = (id) => {
  // Remove 'MaterialIcons/' prefix to match the actual component name
  const iconName = id.replace('MaterialIcons/', '');

  // Get the specific icon component from MaterialIcons
  const IconComponent = MaterialIcons[kebabToCamelCase(iconName)];

  // If the icon is found, return it
  if (IconComponent) {
    return <IconComponent />;
  }

  // Return a default fallback if the icon is not found
  return <MaterialIcons.HelpOutline />;
};